module.exports = __webpack_public_path__ + "img/HongKongTrust3.9a73817e.png";